

// export class FilterDTO implements IFilterDto {
//     employeeCode!: number;
//     employeeName!: number[] | undefined;
//     mobileNumber!: string | undefined;
//     gender!: string | undefined;
//     branch!: string | undefined;
//     department!: string | undefined;
//     designation!: string | undefined;
//     employeeStatus!: string | undefined;
//     applicationStatus!: string | undefined;
//     approverName!: string | undefined;
//     fromDate!: Date | undefined;
//     toDate!: Date | undefined;
//     fromMonth!: Date | undefined;
//     toMonth!: Date | undefined;
//     leaveType!:string | undefined;

//     constructor(data?: IFilterDto) {
//         if (data) {
//             for (var property in data) {
//                 if (data.hasOwnProperty(property))
//                     (<any>this)[property] = (<any>data)[property];
//             }
//         }
//     }

//     init(_data?: any) {
//         if (_data) {
//             this.employeeCode = _data["employeeCode"];
//             this.employeeName = _data["employeeName"];
//             this.leaveType = _data["leaveType"];
//             this.approverName = _data["approverName"];
//             this.mobileNumber = _data["mobileNumber"];
//             this.gender = _data["gender"];
//             this.branch = _data["branch"];
//             this.department = _data["department"];
//             this.designation = _data["designation"];
//             this.employeeStatus = _data["employeeStatus"];
//             this.applicationStatus = _data["applicationStatus"];
//             this.fromDate = _data["fromDate"];
//             this.toDate = _data["toDate"];
//             this.fromMonth = _data["fromMonth"];
//             this.toMonth = _data["toMonth"];
//         }
//     }

//     static fromJS(data: any): FilterDTO {
//         data = typeof data === 'object' ? data : {};
//         let result = new FilterDTO();
//         result.init(data);
//         return result;
//     }

//     toJSON(data?: any) {
//         data = typeof data === 'object' ? data : {};
//         data["employeeCode"] = this.employeeCode;
//         data["employeeName"] = this.employeeName;
//         data["approverName"] = this.approverName;
//         data["leaveType"] = this.leaveType;
//         data["mobileNumber"] = this.mobileNumber;
//         data["gender"] = this.gender;
//         data["branch"] = this.branch;
//         data["department"] = this.department;
//         data["designation"] = this.designation;
//         data["employeeStatus"] = this.employeeStatus;
//         data["applicationStatus"] = this.applicationStatus;
//         data["fromDate"] = this.fromDate;
//         data["toDate"] = this.toDate;
//         data["fromMonth"] = this.fromMonth;
//         data["toMonth"] = this.toMonth;
//         return data; 
//     }
// }

// export interface IFilterDto {
//     employeeCode: number;
//     employeeName: number[] | undefined;
//     approverName: string | undefined;
//     mobileNumber: string | undefined;
//     leaveType: string | undefined;
//     gender: string | undefined;
//     branch: string | undefined;
//     department: string | undefined;
//     designation: string | undefined;
//     employeeStatus: string | undefined;
//     applicationStatus: string | undefined;
//     fromDate: Date | undefined;
//     toDate: Date | undefined;
//     fromMonth: Date | undefined;
//     toMonth: Date | undefined;
// }

export class EnumValue {
    name: string;
    value: string;
}

export class EnumValueNumber {
    name: string;
    value: number;
}

export class FilterAccessDTO {
    showEmployeeCode: boolean;
    showEmployeeName: boolean;
    showMobileNumber: boolean;
    showLeaveType: boolean;
    showGender: boolean;
    showBranch: boolean;
    showDepartment: boolean;
    showDesignation: boolean;
    showEmployeeStatus: boolean;
    showApplicationStatus: boolean;
    showFromDate: boolean;
    showToDate: boolean;
    showFromMonth: boolean;
    showToMonth: boolean;
    showApproverName: boolean;
    showLocation: boolean;
    showEmployeeType:boolean;
    showFinancialYear:boolean;
    showSlabType:boolean;
    showITMethod:boolean;
    showSingleFinancialYear:boolean;
}

export class inoutdata {
    Date: Date;
    Employee: string;
    InTime: Date;
    OutTime: Date;
    PresentHours: number;
    Timing: string;
    LateIn: string;
    earlyTime: string;
}

export class letter {
    name: string;
    employeeCode: number;
    salary: number;
    designation: string;
    prefix: string;
    joiningDate: Date;
    director: string;
    date: Date;
    resign: Date;
    hr:string;
    noticePeriod:string;
    companyWebsite:string;
    contactNo:string;
    email:string;
    companyId:any;
    leader:string;
    city:string;
    CompanyName:string;
    address:string;
    companyLegalName:string;
    resigncreateddate: Date;
    noticeperiodenddate:Date;
}

